import React from 'react';
const benefits = [{
  icon: '🚀',
  title: 'Stop planning by hand',
  desc: 'Complete session units, month by month, from U6s to Seniors — aligned with RFU coaching standards.',
  stat: '−5 hours a week',
  color: 'from-blue-500/20 to-blue-600/5',
  borderColor: 'border-blue-500/20',
  statColor: 'text-blue-300 bg-blue-500/15 border-blue-500/25'
}, {
  icon: '🏉',
  title: 'Coach with total confidence',
  desc: 'Over 100 drills with crystal-clear coaching points: cues, progressions, and safe regressions for every age.',
  stat: '0 guesswork needed',
  color: 'from-green-500/20 to-green-600/5',
  borderColor: 'border-green-500/20',
  statColor: 'text-cta-green bg-cta-green/15 border-cta-green/30'
}, {
  icon: '📋',
  title: 'Captivate the squad on the whiteboard',
  desc: 'Visual diagrams and colour-coded set-plays that make tactics instantly clear for every player.',
  stat: 'Ready in 2 clicks',
  color: 'from-purple-500/20 to-purple-600/5',
  borderColor: 'border-purple-500/20',
  statColor: 'text-purple-300 bg-purple-500/15 border-purple-500/25'
}, {
  icon: '🎓',
  title: 'Develop every player, not just the stars',
  desc: 'Age-grade pathway with progressions for late developers and mixed-ability squads. No player left behind.',
  stat: '100% inclusive',
  color: 'from-secondary/20 to-secondary/5',
  borderColor: 'border-secondary/20',
  statColor: 'text-secondary bg-secondary/15 border-secondary/30'
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-4" data-id="element-3">
          <span className="inline-flex items-center gap-2 text-primary font-bold text-xs sm:text-sm uppercase tracking-wider bg-primary/10 border border-primary/20 px-4 py-1.5 rounded-full" data-id="element-4">
            🎁 What's included
          </span>
        </div>

        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-3 tracking-tight" data-id="element-5">
          What will change on your{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-orange-400" data-id="element-6">
            training pitch
          </span>{' '}
          (and in your weekends).
        </h2>
        <p className="text-text-sec text-base sm:text-lg text-center max-w-2xl mx-auto mb-14" data-id="element-7">
          4 concrete transformations you'll notice{' '}
          <span className="text-text-main font-bold" data-id="element-8">
            from the very first session
          </span>{' '}
          you run.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-7 mb-12" data-id="element-9">
          {benefits.map((benefit, i) => <div key={i} className="bg-bg-alt p-7 sm:p-8 rounded-3xl border border-border-light shadow-xl flex flex-col gap-4 hover:-translate-y-1 hover:border-white/20 transition-all duration-300 relative overflow-hidden group" data-id="element-10">
              <div className={`absolute inset-0 bg-gradient-to-br ${benefit.color} opacity-0 group-hover:opacity-100 transition-opacity duration-500`} data-id="element-11"></div>

              <div className="flex items-center justify-between gap-3 relative z-10" data-id="element-12">
                <div className={`w-14 h-14 rounded-2xl bg-bg-dark border ${benefit.borderColor} flex items-center justify-center text-3xl shadow-inner group-hover:scale-110 transition-transform duration-300`} data-id="element-13">
                  {benefit.icon}
                </div>
                <span className={`text-xs sm:text-sm font-black uppercase tracking-wider px-3 py-1.5 rounded-full border ${benefit.statColor}`} data-id="element-14">
                  {benefit.stat}
                </span>
              </div>

              <h3 className="text-xl sm:text-2xl font-black text-text-main relative z-10 leading-tight" data-id="element-15">
                {benefit.title}
              </h3>

              <p className="text-text-sec leading-relaxed text-base sm:text-lg relative z-10" data-id="element-16">
                {benefit.desc}
              </p>
            </div>)}
        </div>

        <div className="bg-bg-alt border border-cta-green/30 rounded-2xl p-6 sm:p-7 mb-10 max-w-3xl mx-auto relative overflow-hidden" data-id="element-17">
          <div className="absolute inset-0 pointer-events-none" style={{
          background: 'radial-gradient(circle at left center, rgba(22,199,132,0.08) 0%, transparent 60%)'
        }} data-id="element-18"></div>
          <div className="relative flex items-start gap-4" data-id="element-19">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary/30 to-cta-green/20 border border-cta-green/30 flex items-center justify-center text-xl flex-shrink-0" data-id="element-20">
              🏉
            </div>
            <div data-id="element-21">
              <div className="flex items-center gap-2 mb-1" data-id="element-22">
                <span className="text-secondary text-sm" data-id="element-23">⭐⭐⭐⭐⭐</span>
                <span className="text-text-sec text-xs font-medium" data-id="element-24">
                  Verified
                </span>
              </div>
              <p className="text-text-main text-base sm:text-lg font-medium leading-relaxed italic" data-id="element-25">
                "In two weeks I've got my Sundays back. The lads turn up buzzing
                for every session and I'm not stressing on Monday mornings."
              </p>
              <p className="text-text-sec text-sm mt-2 font-medium" data-id="element-26">
                — David G., U12s Head Coach · Leicester
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}